import { mapState } from "vuex";
import { mapGetters } from "vuex";
import store from '../../store';
import i18n from "../../i18n";

export default {
  name: 'app-table',
  components: {    
  },
  props: {    
    'data-products': {
      type: String,
      required: true
    },
    'data-lang' : {
      type: String,
      required: false,
      default: 1033
    },
    'data-kit': {
      type: Number,
      required: true
    },
  },
  data () {
    return {
      alerts: [],
      currency: '€',
      locale: 'en'
    }
  },
  computed: {    
    ...mapState('products', ['products','kit']),   
    ...mapState(['translations']), 
    ...mapGetters(['loading']), 
    totalNeto() {
      let totalneto = 0;
      this.products.forEach(product => {
        totalneto += product.pvp - (product.pvp * product.saleDiscount / 100);
      });
      return totalneto;
    },
    arrayDataProducts() {
      return JSON.parse(this.dataProducts);
    }
  },
  mounted () {    
    if (this.loading == 0) { //ask the store is getting data
      this.$store.dispatch('products/loadProducts', this.arrayDataProducts);
      this.$store.dispatch('products/loadKit', this.dataKit); 
    }   
  },
  created () {
     //Change locale
     switch(+this.dataLang) {
      case 1031:
        this.locale = 'de';
      break;
      case 1033:
        this.locale = 'en';
        break;
      case 1034:
        this.locale = 'es';
        break;
    }  
  },
  methods: {
    format (n) {
      return n.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    imageLoadOnError (e) {
      e.target.src="https://fotos.futurasmus-knxgroup.com/default.png"
    },
    rowClickHandler (product) {
      window.open(`producto.php?busqueda=${product.codProduct}&tipobusqueda=5&cod_producto=${product.codProduct}`, "_blank");
    }
  },
  watch: {
    
  },
  store,
  i18n
}


